/* eslint-disable @typescript-eslint/naming-convention */
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

export interface ImagePasteOptions {
  fileMatchRegex: RegExp;
  disableImagePaste: boolean;
  render?: () => {
    onImagePaste?: (files: File[]) => void;
    onImageDrop?: (files: File[]) => void;
    onDisabledImagePaste?: (text: string) => void;
  };
}

const mapDataItems = (data: DataTransferItemList, fileMatchRegex: RegExp): File[] => {
  return Array.from(data)
    .map(item => (item.type.match(fileMatchRegex) ? item.getAsFile() : null))
    .filter(item => item !== null) as File[];
};

const mapTextItems = async (data: DataTransferItemList): Promise<string> => {
  const fullSet = Array.from(data);
  const plainText = fullSet.find(item => item.type === 'text/plain');
  const richText = fullSet.find(item => item.type === 'text/html');
  return new Promise(resolve => {
    (richText || plainText)?.getAsString(html => {
      const value = html.replace(/<img[^>]*>/g, '');
      resolve(value);
    });
  });
};

export const ImagePaste = Extension.create<ImagePasteOptions>({
  name: 'imagePaste',

  // defaultOptions: {
  //   fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
  //   disableImagePaste: false,
  // },
  addOptions:{
    fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
    disableImagePaste: false,
  },

  addProseMirrorPlugins() {
    const options = this.options;
    const renderer = this.options.render?.();

    return [
      new Plugin({
        key: new PluginKey('imagePasteHandler'),
        props: {
          handlePaste(_view, event) {
            // console.log('handlePaste');
            if (options.disableImagePaste && renderer?.onDisabledImagePaste) {
              // @ts-ignore
              mapTextItems(event?.clipboardData?.items).then(value => {
                if (value) {
                  renderer?.onDisabledImagePaste?.(value);
                }
              });

              return true;
            }

            if (!options.disableImagePaste && renderer?.onImagePaste && event.clipboardData?.items?.length) {
              const files = mapDataItems(event.clipboardData.items, options.fileMatchRegex);

              if (files.length) {
                renderer.onImagePaste(files);

                return true;
              }
            }
            return false;
          },

          handleDrop(_view, event: DragEvent) {
            // console.log('event: ', event.dataTransfer?.files?.length,event.dataTransfer?.files);
            // console.log('_view: ', _view);
            // console.log('handleDrop');
            if (!options.disableImagePaste && event.dataTransfer?.files?.length && renderer?.onImageDrop) {
              const files = mapDataItems(event.dataTransfer.items, options.fileMatchRegex);

              if (files.length) {
                renderer.onImageDrop(files);

                return true;
              }
            }

            return false;
          },
        },
      }),
    ];
  },
});



export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>{
      resolve(reader.result);
    } 
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
}